import React from 'react';
import {useSelector, useHover} from 'polyphony/hooks';
import {TwitterIcon, FacebookIcon, InstagramIcon, EmailIcon, LinkedinIcon, RedditIcon} from 'polyphony/icons';

const selector = ({webpage_title, site_name}) => ({webpage_title, site_name});

const SharingButton = ({href, icon: Icon, size = 22, hoverColor}) => {
    const [{hover}, ref] = useHover();
    return <a ref={ref} style={{padding: 10, display: 'flex', justifyContent: 'center', alignItems: 'center'}} href={href} rel="nofollow noopener" target="_blank">
               <Icon style={hover ? {color: hoverColor} : undefined} height={size} width={size} />
           </a>;
};

const SharingButtons = ({twitter, facebook, reddit, instagram, linkedin, email, url}) => {
    const {webpage_title, site_name} = useSelector(selector);
    url = encodeURIComponent(url ? url : location.href);
    return (
        <div className='polyphony-sharing-buttons' style={{margin: '10px 0', alignItems: 'center', flexFlow: 'row wrap', display: 'inline-flex'}}>
            {twitter && <SharingButton href={`https://twitter.com/intent/tweet?text=${url}`} icon={TwitterIcon} hoverColor="#00ACED" />}
            {facebook && <SharingButton href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} icon={FacebookIcon} hoverColor="#3b5998" />}
            {instagram && <SharingButton href={`#`} icon={InstagramIcon} hoverColor="#833AB4" />}
            {reddit && <SharingButton href={`https://www.reddit.com/submit?url=${url}`} icon={RedditIcon} hoverColor="#FF4500" />}
            {linkedin && <SharingButton icon={LinkedinIcon} href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${webpage_title}&source=${site_name}`} hoverColor="#0077B5" />}
            {email && <SharingButton icon={EmailIcon} href={`mailto:?body=${url}`} hoverColor="lightgray" />}
        </div>
    );
};

export default SharingButtons;

